import { DomeComponent, DomeManipulator, React } from "@lexriver/dome"
import { IBasket } from "../Basket/IBasket"
import { GlobalBasket } from "../GlobalBasket"
import { GlobalUser } from "../GlobalUser"
import { EnumIconNames } from "../enums/EnumIconNames"
import { FormBasketCoupon } from "../forms/FormBasketCoupon"
import css from './Basket.m.scss'
import { BasketExport } from "./BasketExport"
import { BasketProductList } from "./BasketProductList"
import { BasketRemainderWarning } from "./BasketRemainderWarning"
import { BasketStatsOnBottom } from "./BasketStatsOnBottom"
import { BasketText } from "./BasketText"
import { Breadcrumbs } from "./Breadcrumbs"
import { ButtonBack } from "./ButtonBack"
import { Icon } from "./Icon"
import { LinkBack } from "./LinkBack"
import { NewOrder } from "./NewOrder"
import { Input } from "./form/Input"

const filename = 'Basket.tsx'


interface Attrs{
    scrollToOrder?:boolean
    scrollToProductId:number
}
export class Basket extends DomeComponent<Attrs>{
    // comTotalQuantity:TotalQuantity|undefined
    // comRetailSum:RetailSum|undefined
    // comWholesaleSum:WholesaleSum|undefined
    refInputProductListName?:Input
    refScrollTo:HTMLDivElement|undefined

    
    render(){
        // we need to keep this el for events to work
        return <div class={css.basket}></div>
    }

    async renderEmptyBasketAsync(){
        await DomeManipulator.replaceAllChildrenAsync(this.rootElement, <>
            <div style={{textAlign:'center', padding:'10px'}}>
                Ваша корзина пуста, выберите товары из каталога и положите в корзину.
                <br/>
                <br/>
                {/* <LinkBack><Icon iconName={EnumIconNames.LeftBig} />Вернуться в каталог</LinkBack> */}
                <ButtonBack text="вернуться в каталог"></ButtonBack>
                
            </div>
            <div><span class="icon-shopping-basket" style={{fontSize: '30vw', opacity: 0.10, margin:'20px', display:'block', textAlign:'center'}}></span></div>
        </>)
    }

    async renderBasketWithProductsAsync(){
        const canSeeWholesalePrices = await GlobalUser.checkIfCanSeeWholesalePricesAsync()
        const showRemainderWarning = await GlobalUser.checkIfCanSeeWholesalePricesAsync()
        // const isAdmin = await GlobalUser.getUserTypeAsync() === EnumUserType.Administrator
        // const isSMM = await GlobalUser.getUserTypeAsync() === EnumUserType.SMM

        await DomeManipulator.replaceAllChildrenAsync(this.rootElement, <>

        {/* <div class={css.linkBackContainer}>
            {this.renderLinkBack()}
        </div> */}

        <Breadcrumbs items={[{text:'Корзина'}]} />

        <div class={css.headerContainer}>
            
            <div><h1>Корзина</h1></div>
        </div>

        <BasketExport />


        <div>
            <BasketProductList scrollToProductId={this.attrs.scrollToOrder ? 0 : this.attrs.scrollToProductId} />
        </div>

        <div class={css.dropBasketLinkContainer}>
            {this.renderRemoveSelectedProductsLink()}
            <br/>
            <br/>
            {Basket.renderDropBasketLink()}
            
            
        </div>

        

        <BasketStatsOnBottom />

        {!canSeeWholesalePrices &&
            <FormBasketCoupon onCouponApplySuccessAsync={async () => alert('Промокод был успешно применен!')  } />
        }


        {/* <div><pre>{JSON.stringify(GlobalState.loggedInUser.get(), null, 4)}</pre></div> */}

        {showRemainderWarning && 
            <BasketRemainderWarning />
        }

            
        <div ref={ref => this.refScrollTo = ref}></div>


        <BasketText />
        {/* <br /> */}
        <NewOrder />
        <br/>
        <div class={css.linkBackContainer}>
            {this.renderLinkBack()}
        </div>


        
        </>
        )

    }

    protected renderLinkBack(){
        return <LinkBack><Icon iconName={EnumIconNames.LeftBig} />Назад</LinkBack>
    }

    public static renderDropBasketLink(){
        return <a onClick={async () => { 
            if(confirm('Внимание: все товары будут удалены из корзины.\n Очистить корзину?')){ 
                const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
                await basket.clearAsync() 
            } 
        }}><span class="icon-trash-empty"></span>Удалить все товары из корзины</a>
    }

    protected renderRemoveSelectedProductsLink(){
        return <a onClick={async () => { 
            if(confirm('Уверены что хотите удалить отмеченные товары?')){
                const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
                await basket.removeMarkedProductsAsync()
            }
         }}><span class="icon-check"></span>Удалить только отмеченные товары</a>
    }


    async afterRender(){
        //console.log('$$ unmark all products');
        
        // const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        // basket.unmarkAllProducts()

        //console.log('Basket.tsx afterRender()');

        // GlobalBasket.onBasketUpdateEvent.subscribe(async () => {
        //     if(DomeManipulator.isInDom(this.rootElement) == false) return {unsubscribe:true}
        //     await this.updateBasketStatsAsync()
        // })

        GlobalBasket.onBasketEmptyOrFullEvent.subscribe((isEmpty:boolean) => {
            if(DomeManipulator.isInDom(this.rootElement) == false) return {unsubscribe:true}
            this.scheduleUpdate()
        })
        this.scheduleUpdate()
        
    }

    async updateAsync(){
        const basket:IBasket = await GlobalBasket.getCurrentBasketAsync()
        //console.log('Basket.tsx', 'afterRender()', 'basket=', basket)
        if(basket.isEmpty()){
            //console.log('Basket.tsx', 'afterRender()', 'isEmpty()==true')
            await this.renderEmptyBasketAsync()
        } else {
            //console.log('Basket.tsx', 'afterRender()', 'isEmpty()==false')
            await this.renderBasketWithProductsAsync()
        }

        setTimeout(() => {
            if(this.attrs.scrollToOrder && this.refScrollTo){
                // console.log('### scrollTo')
                DomeManipulator.scrollIntoView(this.refScrollTo, 20)
            }
        }, 1000)

    }

}
